/* @jsx h */
import { h, defineComponent } from "vue";

export interface ErrorDisplayerProps {
  error: string;
  title?: string;
  onRetry?: () => void;
}

export const ErrorDisplayer = defineComponent({
  name: "ErrorDisplayer",
  props: {
    error: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Error Loading Data",
    },
    onRetry: {
      type: Function,
      required: false,
    },
  },
  setup(props) {
    return () => (
      <div class="flex items-center justify-center h-full">
        <div class="text-center bg-base-100 rounded-xl p-8 shadow-sm max-w-md">
          <div class="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center mx-auto mb-4">
            <span class="material-symbols-outlined text-error text-2xl">
              error
            </span>
          </div>
          <h3 class="font-medium text-accent mb-2">{props.title}</h3>
          <p class="text-sm text-base-content/60 mb-4">{props.error}</p>
          {props.onRetry && (
            <button
              onClick={() => props.onRetry && props.onRetry()}
              class="btn btn-primary btn-sm"
            >
              <span class="material-symbols-outlined text-base">refresh</span>
              Try Again
            </button>
          )}
        </div>
      </div>
    );
  },
});
